module.exports = __webpack_public_path__ + "img/TechArcherArm1_ua.6a7df77d.webp";